export default __webpack_public_path__ + "static/newLogoPurple-d0ca6bb16e9b9bf9b887ce11c88de92e.png";